import { isMobileScreen } from '@apply/ui';
import { NextButton } from './components/NextButton';
import { CloseButton } from './components/CloseButton';
import { CustomPaymentStep } from '../../../../constants/CustomPaymentStep';

interface PaymentInfoButtonPanelProps {
    nextDisabled: boolean;
    set_paymentStep: React.Dispatch<React.SetStateAction<CustomPaymentStep>>;
    validationGroupRef: React.RefObject<any>;
}

export const PaymentInfoButtonPanel: React.FC<PaymentInfoButtonPanelProps> = ({
    nextDisabled,
    set_paymentStep,
    validationGroupRef,
}) => {
    const mobileScreen = isMobileScreen();
    return (
        <>
            <div className={`customPayment-buttonPanel ${mobileScreen ? 'mobile' : ''}`}>
                <CloseButton />
                <NextButton
                    nextDisabled={nextDisabled}
                    set_paymentStep={set_paymentStep}
                    validationGroupRef={validationGroupRef}
                />
            </div>
        </>
    );
};
